import script from "./WidgetFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetFrame.vue?vue&type=script&setup=true&lang=js"

import "./WidgetFrame.vue?vue&type=style&index=0&id=3ec509d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec509d2"]])

export default __exports__